import React, { useCallback, useImperativeHandle } from 'react'
import { useAnimation } from 'framer-motion'
import { ScrollDownBtn } from '../../styles/introStyles'
import { DownArrow } from '../../assets/svg/icons'

import { useRecoilValue, useSetRecoilState } from 'recoil'
import { currentSection as currentSectionState, lastSection as lastSectionState } from '../../store/uiStore'
import { siteSections as siteSectionsState } from '../../store/dataStore'

const ScrollDownButton = React.forwardRef((props, ref) => {
  const setCurrentSection = useSetRecoilState(currentSectionState)
  const siteSections = useRecoilValue(siteSectionsState)
  const setLastSection = useSetRecoilState(
    lastSectionState
  )

  const handleScrollDown = useCallback((section) => {
    setCurrentSection((last) => section)
    setLastSection((last) => 'intro')
    /* eslint-disable-next-line react-hooks/exhaustive-deps */
  }, [])

  const buttonVars = {
    hidden: {
      opacity: 0,
      y: '-50%',
    },
    visible: {
      opacity: 1,
      y: 0,
    },
  }

  const buttonAnims = useAnimation(buttonVars)

  useImperativeHandle(ref, () => ({
    play () {
      buttonAnims.start('visible')
    },
  }))

  return (
    <ScrollDownBtn
      ref={ref}
      onClick={() => handleScrollDown(siteSections[1].slug)}
      animate={buttonAnims}
      variants={buttonVars}
      transition={{
        duration: 1,
        ease: 'easeOut',
        delay: 3,
      }}
      aria-label='Siguiente'>
      <DownArrow />
    </ScrollDownBtn>
  )
})

export default ScrollDownButton
